import React, { Component } from 'react'
import MyNavbar from "../../components/Navbar/MyNavbar";
import TicketType from '../../components/Ticket/TicketTypeDetail/TicketType'
export default class TicketTypeDetailPage extends Component {
    
    render() {
        return (
            <div>
                 <MyNavbar />
                 <TicketType />
            </div>
        )
    }
}
